import { ActionContext, CommitOptions } from 'vuex';
import { NewsListItem, NewsCategories } from '@app/scripts/api/models/NewsListItem';

export enum MutationTypes {
    FETCHING = 'FETCHING',
    FETCHED = 'FETCHED',
    UPDATE_NEWS_LIST = 'UPDATE_NEWS_LIST',
}

export type State = {
    newsList: Array<NewsListItem> | null,
    newsListConstant: Array<NewsListItem> | null,
    state: symbol,
    collectionId: number | null,
    categories: Array<NewsCategories> | null,
};

export type Mutations <S = State> = {
    [MutationTypes.FETCHING](state: S, uid: number): void
    [MutationTypes.FETCHED](state: S, data: Array<NewsListItem>): void
    [MutationTypes.UPDATE_NEWS_LIST](state: S, data: NewsListItem): void
}

export type AugmentedActionContext = {
    commit<K extends keyof Mutations>(
        key: K,
        payload?: Parameters<Mutations[K]>[1],
        options?: CommitOptions
    ): ReturnType<Mutations[K]>
} & Omit<ActionContext<State, State>, 'commit'>

export interface Actions {
    fetchNews({ commit, state }: AugmentedActionContext, payload: { collectionId: number, limit: number, excludeInvisible: boolean, category: number }): Promise<void>
    toggleNewsActive({ commit, state }: AugmentedActionContext, payload: { uid: number, active: boolean }): Promise<void>
}

export interface Getters {
    newsList (state: State): Array<NewsListItem> | null;
    inactiveNewsList (state: State): Array<NewsListItem> | null;
    activeNewsList (state: State): Array<NewsListItem> | null;
    activeNewsCategories (state: State): Array<NewsCategories> | null;
    inactiveNewsCategories (state: State): Array<NewsCategories> | null;
    state (state: State): symbol;
}
